import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import usePageContent from '../../hooks/usePageContent';

const PromoListHome = () => {
    const { lang } = useParams();
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: "home", field: 'Discount', language: "en-US" });
        }

        if (status === 'done') {
            setDataPromo(data === "" ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status])

    return (
        <section className="discount py-80">
            <div className="container container-md">
                <div className="row gy-4">
                    {
                        dataPromo.length > 0 ? (
                            dataPromo.map((item, index) => (
                                <div className="col-xl-6" key={index}>
                                    <div className="discount-item position-relative rounded-16 bg-main-one-600 overflow-hidden p-28 z-1 h-100 text-center d-flex flex-column align-items-center justify-content-center">
                                        <img
                                            src={"assets/images/shape/offer-shape.png"}
                                            alt=""
                                            className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                                        />
                                        <div className="w-100 flex-between gap-20">
                                            <img
                                                src={item.image !== "" ? item.image : "assets/images/thumbs/discount-img1.png"}
                                                alt=""
                                                className="d-sm-block d-none"
                                            />
                                            <div className="discount-item__content">
                                                <span className="fw-semibold text-white mb-20">
                                                    {item.title !== "" ? item.title : "UP TO 30% OFF"}
                                                </span>
                                                <h6 className="mb-20 text-white">
                                                    {item.description !== "" ? item.description : "57\" Odyssey Neo G9 Dual 4K UHD Quantum Mini-LED"}
                                                </h6>
                                                <Link
                                                    to="/products"
                                                    className="btn btn-main-one-alt rounded-pill gap-8"
                                                    tabIndex={0}
                                                >
                                                    Shop Now
                                                </Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <>
                                <div className="col-xl-6">
                                    <div className="discount-item position-relative rounded-16 bg-main-one-600 overflow-hidden p-28 z-1 h-100 text-center d-flex flex-column align-items-center justify-content-center">
                                        <img
                                            src="assets/images/shape/offer-shape.png"
                                            alt=""
                                            className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                                        />
                                        <div className="w-100 flex-between gap-20">
                                            <img
                                                src="assets/images/thumbs/discount-img1.png"
                                                alt=""
                                                className="d-sm-block d-none"
                                            />
                                            <div className="discount-item__content">
                                                <span className="fw-semibold text-white mb-20">
                                                    UP TO 30% OFF
                                                </span>
                                                <h6 className="mb-20 text-white">
                                                    57" Odyssey Neo G9 Dual 4K UHD Quantum Mini-LED
                                                </h6>
                                                <Link
                                                    to="/products"
                                                    className="btn btn-main-one-alt rounded-pill gap-8"
                                                    tabIndex={0}
                                                >
                                                    Shop Now
                                                </Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="discount-item position-relative rounded-16 bg-main-one-600 overflow-hidden p-28 z-1 h-100 text-center d-flex flex-column align-items-center justify-content-center">
                                        <img
                                            src="assets/images/shape/offer-shape.png"
                                            alt=""
                                            className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                                        />
                                        <div className="w-100 flex-between gap-20">
                                            <img
                                                src="assets/images/thumbs/discount-img1.png"
                                                alt=""
                                                className="d-sm-block d-none"
                                            />
                                            <div className="discount-item__content">
                                                <span className="fw-semibold  text-white mb-20">
                                                    UP TO 30% OFF
                                                </span>
                                                <h6 className="mb-20 text-white">
                                                    57" Odyssey Neo G9 Dual 4K UHD Quantum Mini-LED
                                                </h6>
                                                <Link
                                                    to="/products"
                                                    className="btn btn-main-one-alt rounded-pill gap-8"
                                                    tabIndex={0}
                                                >
                                                    Shop Now
                                                </Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                        )

                    }

                </div>
            </div>
        </section>

    )
}

export default PromoListHome